import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { generate } from '@/helpers/pdf';

const _getHead = () => ['FUNCIONÁRIO', 'LEADS EFETIVADOS', 'TOTAL DE LEADS', 'PORCENTAGEM'];

const _getBody = data => {
  const info = {
    franquia_nome: '',
    list: []
  };
  data.forEach(franquia => {
    info.franquia_nome = franquia.funcionario.nome_franquia;
    info.list.push([franquia.funcionario.nome_funcionario, franquia.leads.efetivado, franquia.leads.total, `${franquia.leads.porcent}%`])
  });

  return info;
} 
const download = (data, meta) => {
  const infosTmp = _getBody(data);
  const infos = {
    head: [_getHead()],
    body: infosTmp.list,
    title: `Relatório Desempenho dos Funcionários - ${infosTmp.franquia_nome}`,
    subTitle: meta.subTitle
  };
  console.log(infos)
    generate(infos, {
    fileName: meta.fileName
  });
 }
 export {
   download
 };


// WEBPACK FOOTER //
// ./src/pdf/DesempenhoFuncionario.js